// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import * as CryptoJS from 'crypto-js';
var cv = '';
function generateRandomString(length) {
  var text = '';
  let codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(((Date.now() * i) * Date.now() + Date.now()) % possible.length);
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export const environment = {
  envName: 'local',
  production: false,
  redirectBaseUrl: '',
  hostname: 'localhost:4200',
  reqtafBaseUrl: 'https://api.devnew.msts.toyota.com/',
  createtafBaseUrl: 'https://api.devnew.msts.toyota.com/',
  reqhistoryBaseUrl: 'https://api.devnew.msts.toyota.com/',
  updatetafBaseUrl: 'https://api.devnew.msts.toyota.com/',
  setuptimeBaseUrl: 'https://api.devnew.msts.toyota.com/',
  setupLocBaseUrl: 'https://api.devnew.msts.toyota.com/',
  setupAgentBaseUrl: 'https://api.devnew.msts.toyota.com/',
  scheduleVehicleBaseUrl: 'https://api.devnew.msts.toyota.com/',
  setupCapacityBaseUrl: 'https://api.devnew.msts.toyota.com/',
  saveTokenBaseUrl: 'https://api.devnew.msts.toyota.com/',
  reportBaseUrl: 'https://api.devnew.msts.toyota.com/',
  downloadUrl: 'https://d3ch1jfyplbgxm.cloudfront.net/',
  loginBaseUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize',
  client_id: '0fd75fb2-0b58-45a7-bc2f-fae96018ae59',
  redirect_uri:'https://devnew.msts.toyota.com',
  // redirect_uri: 'http://localhost:4200',
  loginParameters: '&response_type=code&response_mode=query&scope=openid&',
  state: '23343',
  code_verifier: generateRandomString(128),
  code_challenge: generateCodeChallenge(cv),
  grant_type: 'authorization_code',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  tokenUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  // loginSaveAudit: 'https://bbxfvnwd8f.execute-api.us-west-2.amazonaws.com/dev/itst/'
  loginSaveAudit: 'https://api.devnew.msts.toyota.com/',
  hotelUrl: 'https://api.devnew.msts.toyota.com/',
  fileToken: 'https://api.devnew.msts.toyota.com/',
  signedUrl :'https://api.devnew.msts.toyota.com/',
  bucketName : 'itst-reports-dev/agents-profileImgs'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
